import { useState } from "react";
import PropTypes from "prop-types";
import "react-phone-input-2/lib/high-res.css";
import { twMerge } from "tailwind-merge";

const CustomInputForm = (props) => {
  const {
    label,
    placeholder,
    type = "text",
    renderRight,
    containerStyle,
    textStyle = "",
    bgColor = "bg-white",
    activeOutlineColor = "border-gray",
    inActiveOutlineColor = "border-lightgray",
    className,
    disabled,
  } = props;

  const [isFocused, setIsFocused] = useState(false);

  return (
    <div className={`flex flex-col w-full ${containerStyle}`}>
      {label && (
        <span className="font-montserrat text-primary font-medium text-xs mb-2">
          {label}
        </span>
      )}
      <div
        className={`rounded-lg ${
          type !== "phone" ? "px-3" : ""
        } font-montserrat font-medium text-xs flex items-center border ${bgColor} ${
          isFocused ? activeOutlineColor : inActiveOutlineColor
        } ${className}`}
      >
        <input
          {...props}
          disabled={disabled}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          className={twMerge(
            "flex-1 bg-transparent outline-none whitespace-pre-wrap break-words overflow-hidden py-2.5",
            textStyle
          )}
          placeholder={placeholder}
          type={type ?? "text"}
          style={{ height: "auto", lineHeight: "1.5" }}
        />
        {renderRight}
      </div>
    </div>
  );
};

// Define prop types
CustomInputForm.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.oneOf(["text", "textarea", "dropdown", "date"]),
  renderRight: PropTypes.element,
  containerStyle: PropTypes.string,
  bgColor: PropTypes.string,
  activeOutlineColor: PropTypes.string,
  inActiveOutlineColor: PropTypes.string,
  isTextArea: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  resize: PropTypes.bool,
  name: PropTypes.string.isRequired,
  dropdownList: PropTypes.arrayOf(PropTypes.string),
  rules: PropTypes.object,
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default CustomInputForm;
